import React, { FC, useEffect } from "react";

const HideForms = () => {

    useEffect(() => {
        import("./displaynone.css")

        // let count = 0;
        // const formCheckInterval = setInterval(() => {
        //     const forms = document.querySelectorAll(".sp-form-outer");
        //     if (forms.length > 0) {
        //         forms.forEach(form => {
        //             form.remove();
        //         });

        //         clearInterval(formCheckInterval); // Зупиняємо перевірку
        //     } else {
        //         //console.log("Форма ще не знайдена, повторюємо пошук...");
        //         count = count + 1;
        //         if (count == 10)
        //             clearInterval(formCheckInterval);
        //     }
        // }, 1000);

    }, []);

    return (
        <></>
    );
};

export default HideForms;